import type { Resource } from '../../';
export const content_video_pause: Resource = {"default":"Pause Video"};
